<template>
  
        <ul id="menu" class="Navbar_items">
            
            <li v-for="(items, index) in menulists" :key="index" @click="setActive(index)" :id="'parent_'+index" :class="items.mobile_view">
                <router-link :to="items.to"> 
                    <span class="menuIcon"><i :class="items.headicon"></i></span>
                    <span class="menuText">{{items.name}}</span>
                </router-link>
                <template v-if="items.children !=''">
                    <span  class="arrow"><i class="fa-solid fa-angle-right"></i></span>
                    <ul class="submenu">
                        <li v-for="(childItem, indexs) in items.children" :key="indexs">
                            <router-link :to="childItem.to">{{childItem.name}}</router-link>
                        </li>
                    </ul>
                </template>
            </li>
            
        </ul> 

</template>

<script>
    import MenuItem from "@/components/layout/dashboard/menu/menu-item";
    import store from '@/store';

    export default {
        name: "menu-list",
        components: { MenuItem },
        props: {
            mobile: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                menulists: [],
                oldIndex:null,
            }
        },
        mounted() {
            this.getHeadlist();
            this.$store.commit('setUser');
        },
        methods: {
            getHeadlist() {
                const self = this;
                self.loading = true;
                axios.post('api/headList').then(function (response) {
                  
                    self.menulists = response.data;
                }).catch(function () {
                    self.loading = false;
                });
            },
            setActive(index){
                const self = this;
                let li_element = document.getElementById('parent_'+index);
                let wrap_el = document.getElementById('innerWrap');
                li_element.setAttribute("class","active");
                wrap_el.setAttribute("class","active");
                if(self.oldIndex == null){
                    self.oldIndex = index;
                    
                   

                }
                if(self.oldIndex != index){
                    let li_element = document.getElementById('parent_'+self.oldIndex);
                    li_element.setAttribute("class","");
                    wrap_el.setAttribute("class","");
                    self.oldIndex = index;
                }
                
               
            },
            
        }
    }
</script>